/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPatientDetailsExternalEhrPatientLeadsInner } from './HchbPatientDetailsExternalEhrPatientLeadsInner';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerToJSON,
} from './HchbPatientDetailsExternalEhrPatientLeadsInner';

/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatient
 */
export interface HchbPatientDetailsExternalEhrPatient {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatient
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatient
     */
    type?: HchbPatientDetailsExternalEhrPatientTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatient
     */
    details_push_date?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatient
     */
    details_extraction_date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPatientDetailsExternalEhrPatient
     */
    is_extracting_details?: boolean;
    /**
     * 
     * @type {Array<HchbPatientDetailsExternalEhrPatientLeadsInner>}
     * @memberof HchbPatientDetailsExternalEhrPatient
     */
    leads?: Array<HchbPatientDetailsExternalEhrPatientLeadsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPatientDetailsExternalEhrPatient
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPatientDetailsExternalEhrPatient
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPatientDetailsExternalEhrPatient
     */
    is_generated_document_upload_in_progress?: boolean;
}


/**
 * @export
 */
export const HchbPatientDetailsExternalEhrPatientTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB'
} as const;
export type HchbPatientDetailsExternalEhrPatientTypeEnum = typeof HchbPatientDetailsExternalEhrPatientTypeEnum[keyof typeof HchbPatientDetailsExternalEhrPatientTypeEnum];


/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatient interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HchbPatientDetailsExternalEhrPatientFromJSON(json: any): HchbPatientDetailsExternalEhrPatient {
    return HchbPatientDetailsExternalEhrPatientFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'details_push_date': !exists(json, 'details_push_date') ? undefined : json['details_push_date'],
        'details_extraction_date': !exists(json, 'details_extraction_date') ? undefined : json['details_extraction_date'],
        'is_extracting_details': !exists(json, 'is_extracting_details') ? undefined : json['is_extracting_details'],
        'leads': !exists(json, 'leads') ? undefined : ((json['leads'] as Array<any>).map(HchbPatientDetailsExternalEhrPatientLeadsInnerFromJSON)),
        'is_screener_document_upload_in_progress': !exists(json, 'is_screener_document_upload_in_progress') ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': !exists(json, 'is_additional_document_upload_in_progress') ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': !exists(json, 'is_generated_document_upload_in_progress') ? undefined : json['is_generated_document_upload_in_progress'],
    };
}

export function HchbPatientDetailsExternalEhrPatientToJSON(value?: HchbPatientDetailsExternalEhrPatient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'type': value.type,
        'details_push_date': value.details_push_date,
        'details_extraction_date': value.details_extraction_date,
        'is_extracting_details': value.is_extracting_details,
        'leads': value.leads === undefined ? undefined : ((value.leads as Array<any>).map(HchbPatientDetailsExternalEhrPatientLeadsInnerToJSON)),
        'is_screener_document_upload_in_progress': value.is_screener_document_upload_in_progress,
        'is_additional_document_upload_in_progress': value.is_additional_document_upload_in_progress,
        'is_generated_document_upload_in_progress': value.is_generated_document_upload_in_progress,
    };
}

